import { FC } from 'react';

import { getCDNImageUrl } from '@/helpers/cdn';
import { getRandomDouble } from '@/modules/promotions/helpers';

import {
  ScAnimatedParticlesContainer,
  ScAnimatedParticlesImage,
} from '../styled';

export type Image = {
  src: string;
  position: {
    x: number;
    y: number;
  };
};

export const AnimatedParticles: FC<{ images: Image[] }> = ({ images }) => {
  return (
    <ScAnimatedParticlesContainer>
      {images.map(({ src, position }, index) => (
        <ScAnimatedParticlesImage
          src={getCDNImageUrl(src)}
          key={index}
          alt={`Particle-${index + 1}`}
          positionX={position.x}
          positionY={position.y}
          delay={getRandomDouble(1.5, 2)}
        />
      ))}
    </ScAnimatedParticlesContainer>
  );
};
